module.exports = __webpack_public_path__ + "static/Ferie 2024_compressed-aed9ca18531af3bcaac828173e57803a.pdf";